import React, { FC, ReactNode } from 'react';
import { Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import { addressSchema } from 'FeatureModules/Setting/schemas/company.schema';
import { styled } from '@mui/material/styles';
import AddressFields from './AddressFields';
import { IAddress, ICompany } from 'FeatureModules/Auth/types/company.types';

interface IAddressFormProps {
  address?: IAddress;
  fullWidth?: boolean;
  paddingHorizontal?: number;
  onSubmit: (company: Partial<ICompany>) => void;
  children: (helpers: { submitForm: () => Promise<void>; isSubmitting: boolean }) => ReactNode;
}

const FormGrid = styled(Grid)(({ paddingHorizontal }: { paddingHorizontal?: number }) => ({
  padding: paddingHorizontal ? `0 ${paddingHorizontal}px` : 0,
}));

const AddressForm: FC<IAddressFormProps> = ({
  address,
  fullWidth = false,
  paddingHorizontal,
  onSubmit,
  children,
}) => {
  const handleSubmit = async (values: IAddress) => {
    await onSubmit({
      address: {
        ...values,
      },
    });
  };

  const initialValues = {
    ...(address || addressSchema.default()),
  };

  return (
    <Formik
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={true}
      validationSchema={addressSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, submitForm }) => (
        <Form>
          <FormGrid paddingHorizontal={paddingHorizontal} container spacing={3}>
            <AddressFields fullWidth={fullWidth} />
          </FormGrid>
          {children({
            submitForm,
            isSubmitting,
          })}
        </Form>
      )}
    </Formik>
  );
};

export default AddressForm;
